/*
 *  Tabbed Menu Section above header
 *    Set the active tab based on local storage
 *
 *  Version:
 *    1.0.0 - 2022/11/09
  */
import { CLASS_ACTIVE, CLASS_VISIBLE } from '../../tools/constants/classes';
import { handlize } from '@process-creative/slate-theme-tools';

// Selectors
const TABBED_MENU_ITEM_SELECTOR = '[data-tabbed-menu-item]';
const CONTAINER_SELECTOR = '[data-tabbed-menu]';
const SELECTOR_DESKTOP_SUBMENU = '[data-desktop-submenu]';
const SELECTOR_DESKTOP_MENU_LINK = '[data-desktop-menu-link]';
const SELECTOR_DESKTOP_SUBMENU_IMAGE = '[data-submenu-image]';

// ATTRIBUTES
const ATTR_LINK_HOVER_IMAGE = 'data-link-image';
const ATTR_BD_HOVER_IMAGE = 'data-bd-link-image';
const ATTR_KAS_HOVER_IMAGE = 'data-kas-link-image';

// CLASS
const CLASS_BEN_DAVID_TAB = 'ben-david-tab';

const tabbedMenu = document.querySelector<HTMLElement>(CONTAINER_SELECTOR);

if (tabbedMenu) {
  const tabbedMenuItems = tabbedMenu.querySelectorAll<HTMLElement>(TABBED_MENU_ITEM_SELECTOR);
  const baseUrl = window.location.origin;
  // set active tabbed menu item using local storage
  // grab the href value of ben david
  const benDavidHref = `${baseUrl}${tabbedMenuItems[1].getAttribute('href')}`;
  
  // set the active tab on the first tabbed menu item if NO local storage and if current url is not on the ben david page
    if (!localStorage.getItem('activeTab') && benDavidHref !== window.location.href) {
      localStorage.setItem('activeTab', tabbedMenuItems[0].title);
      tabbedMenuItems[0].classList.add(CLASS_ACTIVE);
      // add a class on the body to identify the active tab
      document.body.classList.add(`${tabbedMenuItems[0].title.toLowerCase()}-tab`);
    } else if (!localStorage.getItem('activeTab') && benDavidHref === window.location.href) {
      // set the active tab on the ben david tab
      localStorage.setItem('activeTab', tabbedMenuItems[1].title);
      tabbedMenuItems[1].classList.add(CLASS_ACTIVE);
      // add a class on the body to identify the active tab
      document.body.classList.add(`${handlize(tabbedMenuItems[1].title)}-tab`);
    }

    // if there is a local storage, update the local storage to the element's title based on the current url
    if (localStorage.getItem('activeTab') !== 'Home' && window.location.pathname === '/') {
      localStorage.setItem('activeTab', tabbedMenuItems[0].title);
    } else if (localStorage.getItem('activeTab') !== 'Ben David' && window.location.href === benDavidHref) {
        localStorage.setItem('activeTab', tabbedMenuItems[1].title);
      // set active class based on local storage
    } else if (localStorage.getItem('activeTab') === tabbedMenuItems[0].title) {
      tabbedMenuItems[0].classList.add(CLASS_ACTIVE);
      document.body.classList.add(`${tabbedMenuItems[0].title.toLowerCase()}-tab`);
    } else if (localStorage.getItem('activeTab') === tabbedMenuItems[1].title) {
      tabbedMenuItems[1].classList.add(CLASS_ACTIVE);
      document.body.classList.add(`${handlize(tabbedMenuItems[1].title)}-tab`);
    }

    // loop through tabbed menu items
    tabbedMenuItems.forEach(element => {
      // add click event to each tabbed menu item
      element.addEventListener('click', () => {
        // get the active tabbed menu item from local storage
        let activeTab = localStorage.getItem('activeTab');
        // set the active tabbed menu item to the current tabbed menu item
        activeTab = element.title;
          // set the active tabbed menu item to local storage
        localStorage.setItem('activeTab', activeTab);
      });
  });

  /*
    Setting hover and unhover events to show submenu images
    on tabbed menus
  */

  const onSubmenuHover = (e:Event, container:HTMLElement) => {
    const self = e.currentTarget as HTMLElement;
    let img = self.getAttribute(ATTR_LINK_HOVER_IMAGE);
    const isBenDavidTab = document.body.classList.contains(CLASS_BEN_DAVID_TAB);

    if (isBenDavidTab) {
      img = self.getAttribute(ATTR_BD_HOVER_IMAGE);
    } else {
      const kasLinkImg = self.getAttribute(ATTR_KAS_HOVER_IMAGE);
      if (kasLinkImg) {
        img = kasLinkImg;
      }
    }

    if (img) {
      const submenuImage = container.querySelector(SELECTOR_DESKTOP_SUBMENU_IMAGE);
      
      if (submenuImage) {
        submenuImage.classList.add(CLASS_VISIBLE);
        submenuImage.innerHTML = `<img src="${img}" class="c-desktop-menu__submenu-image is-hover-image">`;
      }
    }
  }

  const onSubmenuLeave = (e:Event, container: HTMLElement) => {
    const submenuImage = container.querySelector(SELECTOR_DESKTOP_SUBMENU_IMAGE);
    if (submenuImage) submenuImage.classList.remove(CLASS_VISIBLE);
  }

  const desktopSubmenu = Array.from(tabbedMenu.querySelectorAll<HTMLElement>(SELECTOR_DESKTOP_SUBMENU));
  desktopSubmenu.forEach(element => {
    const menuLinkItems = element.querySelectorAll<HTMLAnchorElement>(SELECTOR_DESKTOP_MENU_LINK);

    menuLinkItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', (e) => onSubmenuHover(e, element));
      menuItem.addEventListener('mouseleave', (e) => onSubmenuLeave(e, element));
    })
  })
};
